<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Search History</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="searchHistoryForm">
            <div class="row mt-3">
                <div class="col-xl-8">
                    <div class="row">
                        <div class="col-xl-12" style="height: fit-content;align-self: end;">
                            <button class="excel_btn mr-3 mt-2" style="white-space:nowrap;" (click)="exportData()">
                                <i class="fa fa-file-excel"></i> Export
                            </button>
                            <!-- <button class="btn btn-secondary mr-3 " (click)="Reset()">
                                <i class="fa fa-refresh"></i> Refresh
                            </button> -->
                            <app-button (refreshClicked)="Reset()"></app-button>

                        </div>
                    </div>
                </div>
                <div class="row mx-4" >
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Coverage Status</mat-label>
                            <mat-select class="scrollbarcs" formControlName="coverageStatusType"
                                placeholder="Please Select Coverage Status">
                                <mat-select-filter [displayMember]="'value'" [array]="orderStatusList"
                                    (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Order Status</mat-label>
                            <mat-select class="scrollbarcs" formControlName="orderStatusType"
                                placeholder="Please Select Order Status">
                                <mat-select-filter [displayMember]="'value'" [array]="coverageStatusList"
                                    (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Start Date</mat-label>
                            <input readonly matInput [matDatepicker]="startDate" formControlName="startDate"
                                selectable="isSelectable(date,type)" id="startDate" autocomplete="off"
                                placeholder="Select From Date" class="custom-input-border" specialIsAlphaNumeric
                                (click)="openStartDateDatePicker()">
                            <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDate></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>End Date</mat-label>
                            <input readonly matInput [matDatepicker]="endDate" formControlName="endDate"
                                selectable="isSelectable(date,type)" id="endDate" autocomplete="off" [min]="toMinDate"
                                [max]="toMaxDate" placeholder="Select To Date" class="custom-input-border"
                                specialIsAlphaNumeric (click)="openEndDateDatePicker()">
                            <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #endDate></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6"></div>
                    <div class="col-12 mt-4 d-flex justify-content-center">
                        <button class="btn btn-secondary mr-3" (click)="search()">
                           <i class="fa fa-search mr-2"></i> Search
                        </button>
                    </div>
                </div>
    </div>
    </form>
    <div class="table-responsive mt-2 mt-4">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
            <ng-container matColumnDef="Address">
                <mat-header-cell *matHeaderCellDef mat-sort-header="address">Address
                </mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                    <p class="text-truncate txtalign">
                        {{dataField.address}}</p>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="IpAddress">
                <mat-header-cell *matHeaderCellDef mat-sort-header="queriedIPAddress">Ip Address
                </mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                    <p class="text-truncate txtalign">
                        {{dataField.queriedIPAddress}}</p>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="CustomerEmail">
                <mat-header-cell *matHeaderCellDef mat-sort-header="creationUserId">Customer Email</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                    <p class="text-truncate txtalign">
                        {{dataField.creationUserId}}</p>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SearchedOn">
                <mat-header-cell *matHeaderCellDef mat-sort-header="searchedOn">Searched On</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                    <p class="text-truncate txtalign">
                        {{dataField.searchedOn | date : "dd MMM yyyy HH:mm a"}}</p>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="CoverageStatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header="coverageStatusTypeName">Coverage
                    Status</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                    <p class="text-truncate txtalign">
                        {{dataField.coverageStatusTypeName}}</p>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="OrderStatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header="orderStatusTypeName">Order Status</mat-header-cell>
                <mat-cell *matCellDef="let dataField">
                    <p class="text-truncate txtalign">
                        {{dataField.orderStatusTypeName}}</p>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
            </mat-row>
        </mat-table>
    </div>
    <div class="table_pagenation" [hidden]="dataSource?.filteredData.length<=50">
        <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="50"
            [pageSizeOptions]="[50, 100]">
        </mat-paginator>
    </div>
</div>
</div>